const networkData = {
    "linesOfNetwork": [
        {
            "id": "e92e5c58-9dd4-4da3-b9bc-74da2b9169ea",
            "name": "Reller_all",
            "networkId": "c836c4d1-d36f-4f1f-b957-cbf884b9e1b7",
            "railwayEdgeIds": "0f81e4f2-7351-4300-bca4-b27286712138;3fe63705-dc8c-4f13-b633-b4777dafe26c;3a4aabff-8530-40ec-8c24-c576b93fd157;91b3e768-25c9-4d7c-99ff-da0d37dc8772;158af705-4c4b-4ff2-91d6-e181a0272030;3524335d-b2e7-47f5-936f-ee6053cd5bae;2f83bc33-39bf-43ce-bc32-f14845f55e48;5a0432f0-bce3-4ada-b3e5-fa694cc77d8e;6279d70f-9226-4c76-bc23-fedc46c84526"
        }
    ],
    "edgesOfNetwork": [
        {
            "railwayEdgeId": "0f81e4f2-7351-4300-bca4-b27286712138",
            "railwayEdgeName": "E7",
            "networkId": "c836c4d1-d36f-4f1f-b957-cbf884b9e1b7",
            "length": 127.12036613457059,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.0183019,
                        53.4318593
                    ],
                    [
                        10.0179322,
                        53.4320355
                    ],
                    [
                        10.0174855,
                        53.4321915
                    ],
                    [
                        10.0166567,
                        53.4324338
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "3fe63705-dc8c-4f13-b633-b4777dafe26c",
            "railwayEdgeName": "E8",
            "networkId": "c836c4d1-d36f-4f1f-b957-cbf884b9e1b7",
            "length": 126.42759606674672,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.0183019,
                        53.4318593
                    ],
                    [
                        10.0179908,
                        53.4319676
                    ],
                    [
                        10.0174916,
                        53.4321457
                    ],
                    [
                        10.016632,
                        53.4324026
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "3a4aabff-8530-40ec-8c24-c576b93fd157",
            "railwayEdgeName": "E3",
            "networkId": "c836c4d1-d36f-4f1f-b957-cbf884b9e1b7",
            "length": 64.8354503684254,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.0199281,
                        53.431285
                    ],
                    [
                        10.019063,
                        53.4315546
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "91b3e768-25c9-4d7c-99ff-da0d37dc8772",
            "railwayEdgeName": "E5",
            "networkId": "c836c4d1-d36f-4f1f-b957-cbf884b9e1b7",
            "length": 170.54561880243688,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.0186747,
                        53.4317161
                    ],
                    [
                        10.0184498,
                        53.4318465
                    ],
                    [
                        10.0182372,
                        53.4320208
                    ],
                    [
                        10.0171866,
                        53.4329607
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "158af705-4c4b-4ff2-91d6-e181a0272030",
            "railwayEdgeName": "E6",
            "networkId": "c836c4d1-d36f-4f1f-b957-cbf884b9e1b7",
            "length": 29.451128263938003,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.0186747,
                        53.4317161
                    ],
                    [
                        10.0183019,
                        53.4318593
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "3524335d-b2e7-47f5-936f-ee6053cd5bae",
            "railwayEdgeName": "E9",
            "networkId": "c836c4d1-d36f-4f1f-b957-cbf884b9e1b7",
            "length": 164.82945228030675,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.019063,
                        53.4315546
                    ],
                    [
                        10.0167491,
                        53.4320888
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "2f83bc33-39bf-43ce-bc32-f14845f55e48",
            "railwayEdgeName": "E1",
            "networkId": "c836c4d1-d36f-4f1f-b957-cbf884b9e1b7",
            "length": 260.38395743844495,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.0224356,
                        53.4295491
                    ],
                    [
                        10.0220283,
                        53.4299122
                    ],
                    [
                        10.0217923,
                        53.4301248
                    ],
                    [
                        10.0215321,
                        53.4303933
                    ],
                    [
                        10.0215033,
                        53.430419
                    ],
                    [
                        10.0212961,
                        53.4306042
                    ],
                    [
                        10.0212044,
                        53.4306847
                    ],
                    [
                        10.0210868,
                        53.430788
                    ],
                    [
                        10.0208823,
                        53.4309329
                    ],
                    [
                        10.0205906,
                        53.4310644
                    ],
                    [
                        10.0203466,
                        53.4311651
                    ],
                    [
                        10.0199281,
                        53.431285
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "5a0432f0-bce3-4ada-b3e5-fa694cc77d8e",
            "railwayEdgeName": "E4",
            "networkId": "c836c4d1-d36f-4f1f-b957-cbf884b9e1b7",
            "length": 31.439987227838074,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.019063,
                        53.4315546
                    ],
                    [
                        10.0186747,
                        53.4317161
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "6279d70f-9226-4c76-bc23-fedc46c84526",
            "railwayEdgeName": "E2",
            "networkId": "c836c4d1-d36f-4f1f-b957-cbf884b9e1b7",
            "length": 263.44473936422395,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.0199281,
                        53.431285
                    ],
                    [
                        10.0192632,
                        53.4315197
                    ],
                    [
                        10.0188103,
                        53.4317106
                    ],
                    [
                        10.0185053,
                        53.431885
                    ],
                    [
                        10.0182157,
                        53.4321218
                    ],
                    [
                        10.0172544,
                        53.4329772
                    ]
                ]
            }
        }
    ],
    "network": [
        {
            "networkId": "c836c4d1-d36f-4f1f-b957-cbf884b9e1b7",
            "organisationsId": "0b0ba687-2eb2-4a06-a4bc-2633028de10a",
            "networkName": "Reller",
            "networkIcon": null,
            "location": "",
            "mainCity": "",
            "country": "",
            "centerGeoPoint": {
                "type": "Point",
                "coordinates": [
                    10.01832962,
                    53.4327343
                ]
            },
            "active": 1,
            "defaultStartEdge": "0f81e4f2-7351-4300-bca4-b27286712138",
            "lineMeterOnDefaultStartEdge": 0,
            "defaultEndEdge": "0f81e4f2-7351-4300-bca4-b27286712138",
            "lineMeterOnDefaultEndEdge": 0,
            "timeStamp": "0001-01-01T00:00:00",
            "editorStepProcessed": 0,
            "edgeDataExist": false,
            "trackCount": 0
        }
    ]
}

export default networkData